module.exports = __webpack_public_path__ + "img/20190912104931894.19d87d3d.jpg";